import ExpertsBadge from './Components/ExpertsBadge/ExpertsBadge';
import TestCards from './Components/TestCards/TestCards';
import TestLanguage from './Components/TestLanguage/TestLanguage';

function TestsPanel() {
    return (
        <div className="flex flex-col items-center gap-4">
            <div className="flex flex-col items-center gap-4">
                <TestLanguage />
                <TestCards />
            </div>
            <ExpertsBadge />
        </div>
    );
}

export default TestsPanel;
